import { type BucketLogData, bucketLog } from '@bucketplace/bucket-log';
import { forwardRef } from 'react';
import { Link, type LinkProps } from '@/components/Link/Link';
import { logAmplitude } from '@/utils/Navigation/tracking';

interface LogLinkData {
  linkType?: 'a' | 'link';
  logData?: BucketLogData;
  amplitudeType?: string;
  amplitudeData?: object;
}

interface LogLinkProps<RouteInferType>
  extends LinkProps<RouteInferType>,
    LogLinkData {}

interface LogLinkType {
  // eslint-disable-next-line @typescript-eslint/prefer-function-type
  <RouteInferType>(props: LogLinkProps<RouteInferType>): JSX.Element;
}

// @ts-expect-error generic component
export const LogLink: LogLinkType = forwardRef((props, ref) => {
  const {
    linkType,
    logData,
    onClick,
    amplitudeType,
    amplitudeData = {},
    href,
    ...linkProps
  } = props;
  const isAnchor = linkType === 'a';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    if (logData) {
      bucketLog({
        category: 'click',
        ...logData,
      });
    }
    if (amplitudeType) {
      logAmplitude(amplitudeType, {
        ...amplitudeData,
      });
    }
    onClick?.(e);
  };

  if (isAnchor) {
    return (
      <a
        {...linkProps}
        href={href.toString()}
        ref={ref}
        onClick={handleClick}
      />
    );
  }

  return <Link {...linkProps} href={href} ref={ref} onClick={handleClick} />;
});
